import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import {
    Button,
    InputAdornment,
    Grid,
    CardHeader,
    Card,
    Fab,
    Typography,
    CardContent,
    FormControl,
    CircularProgress,
    InputLabel,
    OutlinedInput,
    IconButton,
    Select,
    MenuItem
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import TodayIcon from '@material-ui/icons/Today';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import moment from "moment";
import { withSnackbar } from 'notistack';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { withTranslation } from 'react-i18next';
import { calculateCommissioningDate, createAsset, updateAsset, getAssetById, getNextInventoryNumber } from '../../api/apiAsset'
import { updateDepreciationRate } from '../../api/apiDepreciationRate';
import { getVendorsSimple } from '../../../vendor/api/apiVendor'
import { getEmployeesSimple } from '../../../employee/api/apiEmployee'
import { getLocationsSimple } from '../../../location/api/apiLocation'
import { getAccountsSimple } from '../../../accountingConfiguration/api/apiAccountingConfiguration'
import { getDepreciationGroupsSimple } from 'views/accountingConfiguration/api/apiDepreciationGroup';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';
import WrappedAutocomplete from 'common/components/custom/WrappedAutocomplete';
import NumberFormat from "react-number-format";
import CreateOrUpdateVendor from 'views/vendor/components/CreateOrUpdateVendor';
import CreateOrUpdateEmployee from "../../../employee/components/CreateOrUpdateEmployee";
import CreateOrUpdateLocation from 'views/location/components/CreateOrUpdateLocation';
import WrappedKeyboardDatePicker from 'common/components/custom/WrappedKeyboardDatePicker';

class CreateOrUpdateAsset extends Component {

    emptyAsset = {
        inventoryId: null,
        standardAttr: {
            assetName: '',
            assetInventoryNumber: '',
            assetType: '',
            note: '',
            dateOfPurchase: null,
            invoiceNumber: '',
            purchaseAmount: '',
            quantity: 1,
            project: '',
            costCentre: '',
            residualValue: 0
        },
        vendorId: null,
        employeeId: null,
        employeeStartDate: null,
        employeeHistoryId: null,
        issuedById: null,
        locationId: null,
        locationHistoryId: null,
        locationStartDate: null,
        assetAccountId: null,
        contraAssetAccountId: null,
        costAccountId: null,
        inpreparationAccountId: null,
        depreciationGroupId: null,
        depreciationRates: {
            rate: null
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialAsset: this.emptyAsset,
            asset: JSON.parse(JSON.stringify(this.emptyAsset)),
            modelToDelete: this.emptyAsset,
            selectedDateOfPurchase: null,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            selectedClient: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            commissioningDate: '',
            vendors: [],
            employees: [],
            locations: [],
            accounts: [],
            depreciationGroups: [],
            selectedVendor: null,
            selectedEmployee: null,
            selectedIssuedBy: null,
            selectedLocation: null,
            selectedDepreciationGroup: null,
            selectedAccount: null,
            selectedContraAccount: null,
            selectedEmployeeStartDate: null,
            selectedLocationStartDate: null,
            openVendorDialog: false,
            openEmployeeDialog: false,
            openLocationDialog: false,
            assetInventoryNumb: '',
            selectedInpreparationAccount: null,
            selectedCostAccount: null,
            selectedFrom: props.location.state && props.location.state.selectedFrom ? props.location.state.selectedFrom : null,
            selectedTo: props.location.state && props.location.state.selectedTo ? props.location.state.selectedTo : null,
            selectedRadioButton: props.location.state && props.location.state.selectedRadioButton ? props.location.state.selectedRadioButton : "currentMonth",
            updateRate: {
                id: null,
                rate: null,
                startDate: null
            },
            createMultiple: false,
            updateRateSwitch: false,
            ratesLength: null
        };
    }

    async componentDidMount() {
        this.props.match.params.id && this.setState({ isLoading: true })
        Promise.all([this.getVendorsSimple(), this.getEmployeesSimple(), this.getLocationsSimple(), this.getAccountsSimple(), this.getDepreciationGroupSimple(), this.props.match.params.id && this.getAssetById()])
            .then(() => {


                !this.props.match.params.id && this.getNextInventoryNumber()
            })
            .catch(error => {
                console.log('Promise rejected:', error);
            })
    }

    getVendorsSimple = (id) => {
        getVendorsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ vendors: response.data.data, selectedVendor: id ? response.data.data.find(v => v.id === id) : null });
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getEmployeesSimple = (id) => {
        getEmployeesSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ employees: response.data.data, selectedEmployee: id ? response.data.data.find(e => e.id === id) : null });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getLocationsSimple = (id) => {
        getLocationsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ locations: response.data.data, selectedLocation: id ? response.data.data.find(l => l.id === id) : null });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getAccountsSimple = () => {
        getAccountsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ accounts: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getNextInventoryNumber = () => {
        getNextInventoryNumber().then((response) => {
            let { asset } = this.state
            asset.standardAttr.assetInventoryNumber = response.data.data
            this.setState({ asset: asset });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getDepreciationGroupSimple = () => {
        getDepreciationGroupsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ depreciationGroups: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    closeDialogVendor = () => {
        this.setState({ openVendorDialog: false })
    }

    closeDialogEmployee = () => {
        this.setState({ openEmployeeDialog: false })
    }

    closeDialogLocation = () => {
        this.setState({ openLocationDialog: false })
    }

    handleChange = (event) => {
        let { asset } = this.state;
        let value = null;
        const target = event.target;
        const name = target.name;
        value = target.type === 'number' ? value = Number(target.value) : target.type === 'checkbox' ? value = target.checked : value = target.value;

        asset.standardAttr[name] = value
        this.setState({ asset: asset })
    };

    handleChangeAmount = (values) => {
        let { asset } = this.state;
        asset.standardAttr.purchaseAmount = values.value;
        this.setState({ asset: asset });
    };

    handleChangeRate = (values) => {
        let { asset } = this.state;
        asset.depreciationRates.rate = values.value;
        this.setState({ asset: asset });
    }

    handleChangeUpdateRate = (values) => {
        let { updateRate } = this.state;
        let updateRateObject = {
            id: updateRate.id,
            rate: Number(values.value),
            startDate: updateRate.startDate
        }
        this.setState({ updateRate: updateRateObject })
    }

    async getAssetById() {
        let requestBody = {
            depreciationFrom: this.state.selectedFrom,
            depreciationTo: this.state.selectedTo
        }
        await getAssetById(this.props.match.params.id, requestBody).then(response => {
            let rateValue = []
            let updateRate = []
            response.data.data.depreciationRates.forEach(rate => {
                return rateValue.push({ rate: rate.rate })
            })
            response.data.data.depreciationRates.forEach(rate => {
                return updateRate.push({ id: rate.id, rate: rate.rate, startDate: rate.startDate })
            })
            let asset = {
                ...response.data.data,
                depreciationRates: rateValue[rateValue.length - 1]
            }
            this.setState({
                asset: asset,
                selectedVendor: this.state.vendors.find(v => v.id === response.data.data.vendorId),
                selectedEmployee: this.state.employees.find(e => e.id === response.data.data.employeeId),
                selectedLocation: this.state.locations.find(l => l.id === response.data.data.locationId),
                selectedIssuedBy: this.state.employees.find(e => e.id === response.data.data.issuedById),
                selectedDepreciationGroup: this.state.depreciationGroups.find(d => d.id === response.data.data.depreciationGroupId),
                selectedAccount: this.state.accounts.find(a => a.id === response.data.data.assetAccountId),
                selectedContraAccount: this.state.accounts.find(a => a.id === response.data.data.contraAssetAccountId),
                selectedCostAccount: this.state.accounts.find(a => a.id === response.data.data.costAccountId),
                selectedInpreparationAccount: this.state.accounts.find(a => a.id === response.data.data.inpreparationAccountId),
                selectedDateOfPurchase: moment(response.data.data.standardAttr.dateOfPurchase, 'DD-MM-YYYY'),
                initialAsset: JSON.parse(JSON.stringify(response.data.data)),
                assetInventoryNumb: response.data.data.standardAttr.assetInventoryNumber,
                updateRate: updateRate[rateValue.length - 1],
                ratesLength: response.data.data.depreciationRates,
                selectedEmployeeStartDate: response.data.data.employeeStartDate,
                selectedLocationStartDate: response.data.data.locationStartDate,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_asset_by_id"), { variant: 'error' });
        });
    }

    handleChangeDateOfPurchase = (date) => {
        let { asset } = this.state;
        asset.standardAttr.dateOfPurchase = moment(date).format("DD-MM-YYYY");
        this.setState({
            asset: asset,
            selectedDateOfPurchase: date
        });
        if (date !== null && date._isValid) {
            this.calculateCommissioningDate(moment(date).format("DD-MM-YYYY"))
        }
    }

    handleChangeEmployeeStartDate = (date) => {
        let { asset } = this.state;
        asset.employeeStartDate = moment(date).format("DD-MM-YYYY");
        this.setState({ asset: asset, selectedEmployeeStartDate: date })
    }

    handleChangeLocationStartDate = (date) => {
        let { asset } = this.state;
        asset.locationStartDate = moment(date).format("DD-MM-YYYY");
        this.setState({ asset: asset, selectedLocationStartDate: date })
    }

    calculateCommissioningDate = (date) => {
        calculateCommissioningDate({ params: { dateOfPurchase: date } }).then((response) => {
            this.setState({ commissioningDate: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    handleChangeVendor = (vendor) => {
        let { asset } = this.state
        if (vendor !== null) {
            asset.vendorId = vendor.id
            this.setState({ selectedVendor: vendor, asset: asset })
        } else {
            asset.vendorId = null
            this.setState({ selectedVendor: null, asset: asset })
        }
    }

    handleChangeEmployee = (employee) => {
        let { asset } = this.state
        if (employee !== null) {
            asset.employeeId = employee.id
            this.setState({ selectedEmployee: employee, asset: asset })
        } else {
            asset.employeeId = null
            this.setState({ selectedEmployee: null, asset: asset })
        }
    }

    handleChangeIssuedBy = (employee) => {
        let { asset } = this.state
        if (employee !== null) {
            asset.issuedById = employee.id
            this.setState({ selectedIssuedBy: employee, asset: asset })
        } else {
            asset.issuedById = null
            this.setState({ selectedIssuedBy: null, asset: asset })
        }
    }

    handleChangeLocation = (location) => {
        let { asset } = this.state
        if (location !== null) {
            asset.locationId = location.id
            this.setState({ selectedLocation: location, asset: asset })
        } else {
            asset.locationId = null
            this.setState({ selectedLocation: null, asset: asset })
        }
    }

    handleChangeAccount = (account) => {
        let { asset } = this.state
        if (account !== null) {
            asset.assetAccountId = account.id
            this.setState({
                selectedAccount: account,
                asset: asset,
                selectedContraAccount: account.relatedAccountId ? this.state.accounts.find(v => v.id === account.relatedAccountId) : null
            })
        } else {
            asset.assetAccountId = null
            this.setState({ selectedAccount: null, asset: asset, selectedContraAccount: null })
        }
    }

    handleChangeContraAccount = (contraAccount) => {
        let { asset } = this.state
        if (contraAccount !== null) {
            asset.contraAssetAccountId = contraAccount.id
            this.setState({ selectedContraAccount: contraAccount, asset: asset })
        } else {
            asset.contraAssetAccountId = null
            this.setState({ selectedContraAccount: null, asset: asset })
        }
    }

    handleChangeCostAccount = (costAccount) => {
        let { asset } = this.state
        if (costAccount !== null) {
            asset.costAccountId = costAccount.id
            this.setState({ selectedCostAccount: costAccount, asset: asset })
        } else {
            asset.costAccountId = null
            this.setState({ selectedCostAccount: null, asset: asset })
        }
    }

    handleChangeInpreparationAccount = (inpreparationAccount) => {
        let { asset } = this.state
        if (inpreparationAccount !== null) {
            asset.inpreparationAccountId = inpreparationAccount.id
            this.setState({ selectedInpreparationAccount: inpreparationAccount, asset: asset })
        } else {
            asset.inpreparationAccountId = null
            this.setState({ selectedInpreparationAccount: null, asset: asset })
        }
    }

    handleChangeDeprecationGroup = (depreciationGroup) => {
        let { asset } = this.state
        if (depreciationGroup !== null) {
            asset.depreciationGroupId = depreciationGroup.id
            asset.depreciationRates.rate = depreciationGroup.regularRate
            this.setState({ selectedDepreciationGroup: depreciationGroup, asset: asset })
        } else {
            asset.depreciationGroupId = null
            asset.depreciationRates.rate = null
            this.setState({ selectedDepreciationGroup: null, asset: asset })
        }
    }

    createOrUpdateAsset = (e) => {
        e.preventDefault();
        const { asset } = this.state;
        if (!this.validateForm()) {
            return;
        }
        let depreciationRatesOject = []
        if (asset.depreciationRates && asset.depreciationRates.rate) {
            depreciationRatesOject.push(asset.depreciationRates)
        }

        let data = {
            ...asset,
            depreciationRates: depreciationRatesOject,
            inventoryId: this.state.selectedInventory.id,
            vendorId: this.state.selectedVendor ? this.state.selectedVendor.id : null,
            employeeId: this.state.selectedEmployee ? this.state.selectedEmployee.id : null,
            locationId: this.state.selectedLocation ? this.state.selectedLocation.id : null,
            contraAssetAccountId: this.state.selectedContraAccount ? this.state.selectedContraAccount.id : null
        }
        let action = this.props.match.params.id ? updateAsset : createAsset;
        action({
            params: {
                createMultiple: this.props.match.params.id ? null : this.state.createMultiple
            }
        }, data).then(response => {
            if (this.props.match.params.id && this.state.updateRate.rate !== this.state.asset.depreciationRates.rate) { updateDepreciationRate(this.state.updateRate, { params: { assetId: this.props.match.params.id } }) }
            this.props.enqueueSnackbar(
                this.props.t(this.props.match.params.id ? 'update_message' : 'create_message', { title: this.props.t('asset') }), { variant: 'success' });
            this.props.history.push({
                pathname: '/assets',
                state: {
                    selectedInventory: this.state.selectedInventory,
                    selectedClient: this.state.selectedClient,
                    selectedFrom: this.state.selectedFrom,
                    selectedTo: this.state.selectedTo
                }
            })
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("asset_inv_number_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(this.props.t(this.props.match.params.id ? 'error_update_message' : 'error_create_message', { title: this.props.t('asset') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { asset } = this.state;
        let valid = true;
        if (!asset.standardAttr.assetName || !asset.standardAttr.assetInventoryNumber || !asset.standardAttr.dateOfPurchase || !asset.standardAttr.purchaseAmount || !asset.depreciationGroupId
        ) {
            valid = false;
        }
        return valid;
    }

    handleResetAssetInventoryNumber = () => {
        let { asset } = this.state;
        !this.props.match.params.id ? this.getNextInventoryNumber() : asset.standardAttr.assetInventoryNumber = this.state.assetInventoryNumb
        this.setState({ asset: asset })
    }

    handleChangeCreateMultiPle = () => {
        this.setState({ createMultiple: !this.state.createMultiple })
    }

    handleChangeSwitchUpdateRate = () => {
        this.setState({ updateRateSwitch: !this.state.updateRateSwitch })
    }

    render() {
        let {
            isLoading,
            asset,
            selectedDateOfPurchase,
            commissioningDate,
            selectedVendor,
            vendors,
            employees,
            selectedEmployee,
            selectedIssuedBy,
            locations,
            selectedLocation,
            depreciationGroups,
            selectedDepreciationGroup,
            accounts,
            selectedAccount,
            selectedContraAccount,
            selectedInventory,
            selectedLocationStartDate,
            selectedEmployeeStartDate,
            openVendorDialog,
            openEmployeeDialog,
            openLocationDialog,
            selectedClient,
            selectedInpreparationAccount,
            selectedCostAccount
        } = this.state
        let { t } = this.props

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let employeesList = []
        let notAssignedObject = { id: null, firstName: 'Not', lastName: 'Assigned', email: '' };
        employees.map(data => { return employeesList.push(data) })
        employeesList.push(notAssignedObject)
        employeesList.sort((a, b) => (a > b) ? 1 : -1)
        let addTitle = t("add_new_asset") + " " + t("in_inventory") + " '" + selectedInventory.inventoryName + "'"
        let updateTitle = t("update_asset") + " " + t("in_inventory") + " '" + selectedInventory.inventoryName + "'"



        let assetTypeList = ["APARAT ZA KAVU", "GRAĐEVINA/OBJEKT", "HLADNJAK", "KLIMA", "LAPTOP", "LICENCE", "MINER", "MOBITEL", "MONITOR", "MREŽA", "NAMJEŠTAJ", "OPAL", "OSTALO", "PC", "PERILICA", "PISAČ", "PROJEKTOR", "REKLAMA", "ROUTER", "SERVER", "SIM", "SLUŠALICE", "SOFTWARE", "STORAGE", "TIPKOVNICA", "UNIŠTAVAČ PAPIRA", "UPS", "VRSTA"]

        return (
            <Grid container direction="row" spacing={2}>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CardHeader
                        style={{ height: '62px' }}
                        title={<Typography
                            variant={"h6"}>{this.props.match.params.id !== undefined ? updateTitle : addTitle}</Typography>}
                        avatar={
                            <Fab
                                size="small"
                                color="secondary"
                                component={Link}
                                to={{
                                    pathname: `/assets`,
                                    state: {
                                        selectedInventory: selectedInventory,
                                        selectedClient: this.state.selectedClient,
                                        selectedFrom: this.state.selectedFrom,
                                        selectedTo: this.state.selectedTo,
                                        selectedRadioButton: this.state.selectedRadioButton
                                    }
                                }}
                            >
                                <ArrowBack />
                            </Fab>
                        } />
                    <Card>
                        <form onSubmit={this.createOrUpdateAsset} noValidate autoComplete="off" spellCheck="false">
                            <CardContent>
                                <Grid container direction="row" spacing={3}>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        required
                                                        label={"asset_name"}
                                                        name="assetName"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.assetName}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={3} lg={2} xl={2}>
                                                <Grid item container>
                                                    <FormControl fullWidth variant="outlined">
                                                        <InputLabel margin="dense">{this.props.t("asset_inventory_number")}</InputLabel>
                                                        <OutlinedInput
                                                            variant="outlined"
                                                            margin="dense"
                                                            name="assetInventoryNumber"
                                                            label={this.props.t("asset_inventory_number")}
                                                            size="small"
                                                            id="assetInventoryNumber"
                                                            value={asset.standardAttr.assetInventoryNumber}
                                                            onChange={this.handleChange}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle reset asset inv number"
                                                                        onClick={this.handleResetAssetInventoryNumber}
                                                                    >
                                                                        {<RefreshIcon />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={3} lg={2} xl={2}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel id="demo-simple-select-outlined-label" margin="dense">{this.props.t("asset_type")}</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="assetType"
                                                            name="assetType"
                                                            value={asset.standardAttr.assetType}
                                                            onChange={this.handleChange}
                                                            label={this.props.t("asset_type")}
                                                            size="small"
                                                            margin="dense">
                                                            {assetTypeList.map(data => { return <MenuItem key={data} value={data}>{data}</MenuItem> })}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        label={"note"}
                                                        name="note"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.note}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedKeyboardDatePicker
                                                        name="selectedDateOfPurchase"
                                                        label={this.props.t("date_of_purchase")}
                                                        value={selectedDateOfPurchase ? moment(selectedDateOfPurchase, "DD-MM-YYYY") : null}
                                                        onChange={this.handleChangeDateOfPurchase}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <Grid item container>
                                                    <NumberFormat
                                                        required
                                                        customInput={WrappedTextField}
                                                        label={"purchase_amount"}
                                                        thousandSeparator={true}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2}
                                                        value={asset.standardAttr.purchaseAmount}
                                                        onValueChange={this.handleChangeAmount}
                                                        suffix=" HRK"
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={1} xl={1}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        required
                                                        label={"quantity"}
                                                        type="number"
                                                        name="quantity"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.quantity}
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 1
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {!this.props.match.params.id && <Grid item container direction="column" xs={2} sm={2} md={2} lg={1} xl={1}>
                                                <Grid item container>
                                                    <WrappedFromControlLabel
                                                        onChange={this.handleChangeCreateMultiPle}
                                                        name="multiple"
                                                        checked={this.state.createMultiple}
                                                        label={"multiple"}
                                                    />
                                                </Grid>
                                            </Grid>}
                                            {this.state.createMultiple && <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <Grid item container>
                                                    <Alert severity="warning" variant="filled" style={{ height: '40px' }}>Inserting {asset.standardAttr.quantity} asset(s)</Alert>
                                                </Grid>
                                            </Grid>}

                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <Grid item container>
                                                        <FormControl variant="outlined" fullWidth>
                                                            <WrappedAutocomplete
                                                                required
                                                                label={"depreciation_group"}
                                                                placeholder={"depreciation_group"}
                                                                name="selectedDepreciationGroup"
                                                                value={selectedDepreciationGroup || null}
                                                                options={depreciationGroups}
                                                                onChange={this.handleChangeDeprecationGroup}
                                                                getOptionLabel={option => option.name ? option.name : ""}
                                                                getOptionSelected={(option, value) => option.id === value.id}
                                                                renderOption={option => (
                                                                    <React.Fragment>
                                                                        {option.name ? option.name : ""}
                                                                    </React.Fragment>
                                                                )}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        label={"residual_value"}
                                                        name="residualValue"
                                                        type="number"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.residualValue}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        label={"invoice_number"}
                                                        name="invoiceNumber"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.invoiceNumber}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        label={"project"}
                                                        name="project"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.project}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        label={"cost_centre"}
                                                        name="costCentre"
                                                        onChange={this.handleChange}
                                                        value={asset.standardAttr.costCentre}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"asset_account"}
                                                            placeholder={"asset_account"}
                                                            name="selectedAccount"
                                                            value={selectedAccount || null}
                                                            options={accounts}
                                                            onChange={this.handleChangeAccount}
                                                            getOptionLabel={option => option.account ? option.account + " -" + option.description : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.account ? option.account + " -" + option.description : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"contra_asset_account"}
                                                            placeholder={"contra_asset_account"}
                                                            name="selectedContraAccount"
                                                            value={selectedContraAccount || null}
                                                            options={accounts}
                                                            /* getOptionDisabled={(option) => option === accounts.find(a => a === selectedAccount)} */
                                                            onChange={this.handleChangeContraAccount}
                                                            getOptionLabel={option => option.account ? option.account + " -" + option.description : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.account ? option.account + " -" + option.description : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"cost_account"}
                                                            placeholder={"cost_account"}
                                                            name="selectedCostAccount"
                                                            value={selectedCostAccount || null}
                                                            options={accounts}
                                                            onChange={this.handleChangeCostAccount}
                                                            getOptionLabel={option => option.account ? option.account + " -" + option.description : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.account ? option.account + " -" + option.description : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"inpreparation_account"}
                                                            placeholder={"inpreparation_account"}
                                                            name="selectedInpreparationAccount"
                                                            value={selectedInpreparationAccount || null}
                                                            options={accounts}
                                                            /* getOptionDisabled={(option) => option === accounts.find(a => a === selectedAccount)} */
                                                            onChange={this.handleChangeInpreparationAccount}
                                                            getOptionLabel={option => option.account ? option.account + " -" + option.description : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.account ? option.account + " -" + option.description : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={3}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"vendor"}
                                                            name="selectedVendor"
                                                            value={selectedVendor || null}
                                                            options={vendors}
                                                            onChange={this.handleChangeVendor}
                                                            getOptionLabel={option => option.name ? option.name : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.name ? option.name : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={1}>
                                                <Grid item container>
                                                    <Button color="primary" variant="contained" className="button-with-border-radius" onClick={() => this.setState({ openVendorDialog: true })}><AddIcon /> {this.props.t("add_new")}</Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={3}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"employee"}
                                                            placeholder={"employee"}
                                                            name="selectedEmployee"
                                                            value={selectedEmployee || null}
                                                            options={employeesList}
                                                            onChange={this.handleChangeEmployee}
                                                            getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={1}>
                                                <Grid item container>
                                                    <Button color="primary" variant="contained" className="button-with-border-radius" onClick={() => this.setState({ openEmployeeDialog: true })}><AddIcon /> {this.props.t("add_new")}</Button>
                                                </Grid>
                                            </Grid>

                                            <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={4}>
                                                <Grid item container>
                                                    <WrappedKeyboardDatePicker
                                                        name="selectedEmployeeStartDate"
                                                        label={this.props.t("starting_date_of_usage")}
                                                        value={selectedEmployeeStartDate ? moment(selectedEmployeeStartDate, "DD-MM-YYYY") : null}
                                                        onChange={this.handleChangeEmployeeStartDate}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={4}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={this.props.t("issued_by")}
                                                            placeholder={this.props.t("issued_by")}
                                                            name="selectedIssuedBy"
                                                            value={selectedIssuedBy || null}
                                                            options={employees}
                                                            onChange={this.handleChangeIssuedBy}
                                                            getOptionLabel={option => option.firstName ? option.firstName + " " + option.lastName + ", " + option.email : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.firstName ? option.firstName + " " + option.lastName + ", " + option.email : ""}
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={3}>
                                                <Grid item container>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <WrappedAutocomplete
                                                            label={"location"}
                                                            placeholder={"location"}
                                                            name="selectedLocation"
                                                            value={selectedLocation || null}
                                                            options={locations}
                                                            onChange={this.handleChangeLocation}
                                                            getOptionLabel={option => option.address ?

                                                                option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderOption={option => (
                                                                <React.Fragment>
                                                                    {option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""
                                                                    }
                                                                </React.Fragment>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={1}>
                                                <Grid item container>
                                                    <Button color="primary" variant="contained" className="button-with-border-radius" onClick={() => this.setState({ openLocationDialog: true })}><AddIcon /> {this.props.t("add_new")}</Button>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={4}>
                                                <Grid item container>
                                                    <WrappedKeyboardDatePicker
                                                        name="selectedLocationStartDate"
                                                        label={this.props.t("starting_date_of_usage")}
                                                        value={selectedLocationStartDate ? moment(selectedLocationStartDate, "DD-MM-YYYY") : null}
                                                        onChange={this.handleChangeLocationStartDate}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {this.props.match.params.id && <>
                                    <hr />
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Typography variant="h6" gutterBottom component="div">{t("rate")}</Typography>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <Grid item container>
                                                    <NumberFormat
                                                        disabled={!this.state.updateRateSwitch}
                                                        allowedDecimalSeparators={[".", ","]}
                                                        customInput={WrappedTextField}
                                                        decimalScale={2}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        value={this.state.updateRate.rate}
                                                        onValueChange={this.handleChangeUpdateRate}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {this.props.match.params.id && <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={1}>
                                                <Grid item container>
                                                    <WrappedFromControlLabel
                                                        onChange={this.handleChangeSwitchUpdateRate}
                                                        name="updateRateSwitch"
                                                        checked={this.state.updateRateSwitch}
                                                        label={"update"}
                                                    />
                                                </Grid>
                                            </Grid>}
                                            {this.state.updateRateSwitch && this.state.ratesLength && this.state.ratesLength.length > 1 && <Grid item container direction="column" xs={7} sm={7} md={7} lg={7} xl={5}>
                                                <Grid item container>
                                                    <Alert severity="warning" variant="filled" style={{ height: '40px' }}> {this.props.t("alert_update_asset_rate",)}{<span onClick={() => this.props.history.push({
                                                        pathname: `/assetRate/${this.props.match.params.id}`,
                                                        state: {
                                                            selectedInventory: selectedInventory,
                                                            selectedClient: this.state.selectedClient,
                                                            selectedFrom: this.state.selectedFrom,
                                                            selectedTo: this.state.selectedTo
                                                        }
                                                    })} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} > {this.props.t("rate_detail_page")}
                                                    </span>} </Alert>
                                                </Grid>
                                            </Grid>}
                                        </Grid>
                                    </Grid>
                                </>}
                                {!this.props.match.params.id && <>
                                    <hr />
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Typography variant="h6" gutterBottom component="div">{t("depreciation_rate")}</Typography>
                                    </Grid>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <NumberFormat
                                                        allowedDecimalSeparators={[".", ","]}
                                                        disabled={!!this.props.match.params.id}
                                                        customInput={WrappedTextField}
                                                        decimalScale={2}
                                                        label={"rate"}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        value={selectedDepreciationGroup !== null ? asset.depreciationRates.rate : asset.depreciationRates.rate !== "" ? asset.depreciationRates.rate : ""}
                                                        onValueChange={this.handleChangeRate}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        disabled
                                                        label={"regular_rate"}
                                                        name="rate"
                                                        onChange={this.handleChange}
                                                        value={selectedDepreciationGroup !== null ? selectedDepreciationGroup && selectedDepreciationGroup.regularRate : ""}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment
                                                                position="start">{t("regular")}</InputAdornment>
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        disabled
                                                        label={"accelerated_rate"}
                                                        name="rate"
                                                        onChange={this.handleChange}
                                                        value={selectedDepreciationGroup !== null ? selectedDepreciationGroup && selectedDepreciationGroup.acceleratedRate : ""}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment
                                                                position="start">{t("accelerated")}</InputAdornment>
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                </Grid>
                                            </Grid>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container>
                                                    <WrappedTextField
                                                        disabled
                                                        label={"commissioning_date"}
                                                        name="rate"
                                                        onChange={this.handleChange}
                                                        value={commissioningDate}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">
                                                                <TodayIcon /></InputAdornment>
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid></>}

                                <Grid container direction="row" spacing={3}>
                                    <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container direction="row" spacing={3}>
                                            <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Grid item container style={{ marginTop: '10px' }}>
                                                    <Button type="submit" color="secondary" variant="contained" disabled={!this.validateForm()}>
                                                        {this.props.match.params.id ? t("update") : t("create")}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </form>
                    </Card>
                </Grid>
                <CreateOrUpdateVendor
                    isOpen={openVendorDialog}
                    onClose={this.closeDialogVendor}
                    selectedClient={selectedClient}
                    assetFlag={true}
                    getVendorsSimple={(id) => this.getVendorsSimple(id)}
                />
                <CreateOrUpdateEmployee
                    isOpen={openEmployeeDialog}
                    onClose={this.closeDialogEmployee}
                    selectedClient={selectedClient}
                    assetFlag={true}
                    getEmployeesSimple={(id) => this.getEmployeesSimple(id)}
                />
                <CreateOrUpdateLocation
                    isOpen={openLocationDialog}
                    onClose={this.closeDialogLocation}
                    selectedClient={selectedClient}
                    assetFlag={true}
                    getLocationsSimple={(id) => this.getLocationsSimple(id)}
                />
            </Grid>
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateAsset)));
